module.exports = __webpack_public_path__ + "img/pr-13.544fb25b.png";